(() => {
  if (customElements.get('fh-customer-reviews')) return;

  customElements.define('fh-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fh-customer-reviews__track');
      this.cards = this.track ? [...this.track.querySelectorAll('.fh-customer-reviews__card')] : [];
      this.reviewCards = this.cards.filter(card => card.dataset.fhReviewCard === 'true');
      this.buttons = [...this.querySelectorAll('[data-fh-reviews-direction]')];
      this.progress = this.querySelector('[data-fh-reviews-progress]');
      this.events = new AbortController();

      if (!this.track || !this.cards.length) return;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.move(Number(button.dataset.fhReviewsDirection));
      }, { signal: this.events.signal }));
      this.track.addEventListener('scroll', () => this.update(), { signal: this.events.signal, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }

    move(direction) {
      const first = this.cards[0];
      const second = this.cards[1];
      const step = second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
      const visible = Math.max(1, Math.round(this.track.clientWidth / step));
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: step * visible * direction, behavior });
    }

    update() {
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
        .filter(({ rect }) => rect.left >= bounds.left - 2 && rect.left < bounds.right - 24);
      const first = visible[0]?.index ?? 0;
      const last = visible.at(-1)?.index ?? first;
      const showingCta = visible.some(({ index }) => this.cards[index]?.dataset.fhReviewCta === 'true');
      if (this.progress) {
        this.progress.textContent = showingCta
          ? 'Read all reviews'
          : `${first + 1}${last > first ? `–${last + 1}` : ''} of ${this.reviewCards.length} reviews`;
      }
      if (this.buttons[0]) this.buttons[0].disabled = this.track.scrollLeft < 2;
      if (this.buttons[1]) this.buttons[1].disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
    }
  });
})();
